import { noticeError } from 'monitoring/initNewRelic';

import { showToast, TOAST_TYPE } from 'utility/toast';

const SMS_SOUND_URL = 'https://isa-public.nyc3.cdn.digitaloceanspaces.com/SMS%20Message%20Ding.mp3';
const INTERNAL_SOUND_URL =
  'https://isa-public.nyc3.cdn.digitaloceanspaces.com/Dashboard%20+%20Internal%20Message%20Ding.mp3';

const BLOCKED_SOUND_MESSAGE =
  'Notification sounds are blocked by your browser. Click anywhere on the page, ' +
  "or set this site's Sound permission to Allow.";

export function createNotificationSounds() {
  const smsSound = new Audio(SMS_SOUND_URL);
  const internalSound = new Audio(INTERNAL_SOUND_URL);
  const reportedErrorNames = new Set<string>();
  let blockedToastShown = false;

  // Browsers reject programmatic audio.play() until the page has received a user
  // gesture (ISA-4535). Surface failures instead of failing silently every poll:
  // each distinct failure cause goes to New Relic once per page load, and the
  // autoplay-policy rejection additionally shows a one-time toast. The two are
  // deduped separately so an unrelated failure (e.g. an unreachable sound CDN)
  // can never swallow the autoplay warning.
  const reportBlockedPlayback = (error: unknown) => {
    const err = error instanceof Error ? error : new Error(String(error));

    if (!reportedErrorNames.has(err.name)) {
      reportedErrorNames.add(err.name);
      noticeError(err);
    }

    // showToast drops toasts while the tab is hidden, so only count the warning
    // as delivered when it can actually render.
    if (err.name === 'NotAllowedError' && !blockedToastShown && !document.hidden) {
      blockedToastShown = true;
      showToast({ message: BLOCKED_SOUND_MESSAGE, type: TOAST_TYPE.WARNING });
    }
  };

  const play = (sound: HTMLAudioElement) => {
    sound.play().catch(reportBlockedPlayback);
  };

  return {
    playSmsNotification: () => play(smsSound),
    playInternalNotification: () => play(internalSound),
  };
}

export const notificationSounds = createNotificationSounds();
